import { forwardRef } from 'react';
import { Link, LinkProps, useHistory, useLocation } from 'react-router-dom';

import { ButtonBase } from '@mui/material';
import { ChevronLeftIcon } from 'icons';

type BackButtonProps =
  | {
      onClick?(): void;
      href?: never;
    }
  | {
      onClick?: never;
      href: string;
    };

const LinkComponent = forwardRef<HTMLAnchorElement, LinkProps>(({ to, ...props }, ref) => (
  <Link innerRef={ref} to={to} {...props} />
));

export const BackButton = ({ onClick, href }: BackButtonProps) => {
  const { pathname } = useLocation();
  const history = useHistory();
  const pathnames = pathname.split('/').filter(Boolean);

  const handleBackButtonClick = () => {
    history.push(`/${pathnames.slice(0, -1).join('/')}`);
  };

  return (
    <ButtonBase
      disableRipple
      sx={({ typography }) => ({ ...typography['natter-text-sm'], fontWeight: 500, gap: 0.25 })}
      {...(href ? { LinkComponent, to: href } : { onClick: onClick ?? handleBackButtonClick })}
    >
      <ChevronLeftIcon fontSize="small" />
      Back
    </ButtonBase>
  );
};
